import React from "react";

const FacultyProfilePage = ({ name, image, profileImage, bio }) => {
  return (
    <>
      {/* Top Half-Screen Banner Section */}
      <section className="relative h-[50vh] w-full overflow-hidden">
        <div className="relative w-full h-full overflow-hidden">
          {/* 🔳 Overlay */}
          <div className="absolute inset-0 bg-black/50 z-10"></div>

          {/* 🖼️ Image */}
          <img
            src={image}
            alt={`${name} banner`}
            className="absolute top-[-25%] h-[150%] w-full object-cover z-0"
          />

          {/* 🧾 Heading on top of overlay */}
          <h1 className="absolute inset-0 flex items-center justify-center text-white text-5xl font-extrabold text-center z-20">
            {name}
          </h1>
        </div>
      </section>

      {/* Scroll Down Section - Faculty Profile */}
      <section className="grid grid-cols-1 lg:grid-cols-2 pt-20 pb-20">
        {/* Left - Faculty Full Image */}
        <div className="flex items-center justify-center">
          <img
            src={profileImage}
            alt={`${name} profile`}
            className="w-80 h-auto object-cover rounded shadow-xl"
          />
        </div>

        {/* Right - Faculty Bio */}
        <div className="flex flex-col justify-center pr-40 bg-white">
          <h2 className="text-3xl font-bold mb-4">{name}</h2>
          <p className="text-gray-700 text-base leading-relaxed text-justify">
            {bio.split('\n').map((line, index) => (
              <span key={index}>
                {line}
                <br />
              </span>
            ))}
          </p>
        </div>
      </section>
    </>
  );
};

export default FacultyProfilePage;